import React from 'react';
import { Link } from 'react-router-dom';

import linecon from '../pinstripe-icon-white.png';
import icon from '../ps-icon.png';
import wordmark from '../pinstripe-wordmark.png';

const Brand = () => {
  return(
    <Link className="brand" to="/apps">
      <img src={icon} className="App-icon" alt="pinstripe icon" />
      <img src={wordmark} className="App-wordmark" alt="pinstripe wordmark" />
    </Link>
  );
}

export default Brand;


// WEBPACK FOOTER //
// ./src/components/BrandDash.js